import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import awardPrizeService from 'lib/services/awardPrizeService';
import { showModal } from 'lib/components/Modal';
import { ORDER_STATE } from 'lib/constants/order';
import { fetchOrderPackage, fetchWUJIActivity } from 'lib/apis';
import { useUserOrderStore } from 'lib/store/userOrderStore';
import { captchaModalInit } from 'lib/container/SMSCaptchaModal';
import { generatorOrderUrl, getGiftBtnType, getPackageName, getPureText } from 'lib/utils/util';
import channelService from 'lib/services/channelService';
import { showOrderMobileInput } from 'lib/components/MobileInput';
import { OPERATOR_TYPE } from 'lib/constants/operator';
import { AWARD_TYPES } from 'lib/constants/award';
import { addReportPublicParams, report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { currentUrlParams } from 'lib/utils/url';
import { showLotteryResultDialog } from 'lib/components/LotteryResultDialog';
import { useLotteryPrizeStore } from 'lib/store/lotteryPrizeStore';
import { useUserRewardStore } from 'lib/store/userRewardStore';
import { useMobileStore } from 'lib/store/mobileStore';
import { useGlobalStore } from 'lib/store';
import './styles.scss';

export default function LotteryButton({ data, commonStyle }) {
  const { cmccActivityId, unionActivityId, telcomActivityId, receivedBtnImg, tobeReceiveBtnImg } = data;
  const userOrderInfo = useUserOrderStore((state) => state.userOrderInfo);
  const mobileInput = useMobileStore((state) => state.inputMobile);
  const { queryCommonPrizeResult } = useUserRewardStore((state) => state);
  const globalStore = useGlobalStore((state) => state);
  const [refresh, setRefresh] = useState(false);
  const {
    queryLotteryPrizeResult,
    setCurrentReceivedPrizes,
    remainLotteryCount,
    queryRemainLotteryCount,
    setLotteryActId,
  } = useLotteryPrizeStore((state) => state);

  const [actId, setActId] = useState(-1);

  const isReceived = useMemo(() => remainLotteryCount === 0, [remainLotteryCount]);

  useEffect(() => {
    if (!userOrderInfo?.orderState || actId === -1) return;
    const isValidateOrder = [ORDER_STATE.CANCELING, ORDER_STATE.CANCEL_SUCCESS, ORDER_STATE.ORDER_SUCCESS].includes(
      userOrderInfo?.orderState,
    );

    if (!isValidateOrder) {
      return;
    }
    queryRemainLotteryCount();
  }, [refresh, userOrderInfo, actId]);

  useEffect(() => {
    if (!userOrderInfo?.orderState || actId === -1) return;
    const isValidateOrder = [ORDER_STATE.CANCELING, ORDER_STATE.CANCEL_SUCCESS, ORDER_STATE.ORDER_SUCCESS].includes(
      userOrderInfo?.orderState,
    );

    if (!isValidateOrder) {
      return;
    }

    queryLotteryPrizeResult();
  }, [userOrderInfo, actId]);

  useEffect(() => {
    if (!userOrderInfo?.operatorType) return;
    let actId;
    switch (userOrderInfo?.operatorType) {
      case OPERATOR_TYPE.CMCC: {
        actId = cmccActivityId;
        break;
      }
      case OPERATOR_TYPE.UNICOM: {
        actId = unionActivityId;
        break;
      }
      case OPERATOR_TYPE.TELCOM: {
        actId = telcomActivityId;
        break;
      }
    }
    setLotteryActId(+actId);
    setActId(+actId);
  }, [userOrderInfo]);

  const lotterySuccessCallback = (list) => {
    // list为单词抽奖次数
    report(ATTA_REPORT.MULTIPLE_LOTTERY.LOTTERY_RESULTMODAL_VIEW);
    setCurrentReceivedPrizes(list);
    setRefresh((state) => !state);
    //同步奖励列表 我的奖励红点展示
    queryCommonPrizeResult(mobileInput, true);
    showLotteryResultDialog({
      showConfirmButton: true,
      title: '- 恭喜获得 -',
      confirmButtonText: '一键翻奖',
    });
  };

  // 触发领奖
  const receiveGift = async () => {
    if (isReceived) {
      // 提示当前礼包已领取
      return;
    }
    addReportPublicParams({
      orderTriggerType: getGiftBtnType(AWARD_TYPES.LOTTERY),
    });
    report(ATTA_REPORT.RECEIVE_PRIZE.LOTTERY);
    switch (userOrderInfo.orderState) {
      case ORDER_STATE.CANCELING:
      case ORDER_STATE.CANCEL_SUCCESS:
      case ORDER_STATE.ORDER_SUCCESS: {
        report(ATTA_REPORT.MULTIPLE_LOTTERY.LOTTERY);
        awardPrizeService.multipleLottery(+actId, lotterySuccessCallback);
        return;
      }

      case ORDER_STATE.PLACE_ORDER: {
        if (mobileInput !== userOrderInfo?.orderMobile) {
          showOrderMobileInput(AWARD_TYPES.RIGHTS);
          return;
        }
        if (userOrderInfo?.operatorType === OPERATOR_TYPE.UNICOM) {
          const subStatTag = currentUrlParams.getCurrentParams('SubStatTag') || channelService.channelTag;
          const shareToken = currentUrlParams.getCurrentParams('shareToken');
          const redirectURL = generatorOrderUrl(userOrderInfo);
          report(ATTA_REPORT.MULTIPLE_LOTTERY.PLACE_ORDER);
          const res = await fetchOrderPackage({
            packageId: userOrderInfo?.pId || '',
            channelCode: channelService.channelCode,
            mobile: userOrderInfo?.orderMobile || '',
            subStatTag,
            redirectURL,
            shareToken,
          });
          if (res?.code !== 0) return;
          const { url, orderMethod } = res?.data || {};

          // 1代表需要跳转到订单页
          if (url && orderMethod === 1) {
            window.location.href = url;
            return;
          }
          return;
        }
        const res = await fetchWUJIActivity();
        if (res?.code !== 0) return;
        const activityConfigList = res?.data || [];
        const {
          price_desc: packagePrice,
          package_name: packageName,
          is_promotional: isPromotional,
          subscribe_hint: orderTips,
        } = activityConfigList.find((c) => c.p_id === userOrderInfo.pId) || {};
        const { smsModalTheme } = globalStore;
        showModal(
          captchaModalInit({
            channelCode: channelService.channelCode,
            mobile: userOrderInfo.orderMobile,
            operatorType: userOrderInfo.operatorType,
            packageId: userOrderInfo.pId,
            priceDesc: packagePrice,
            packageName: getPackageName(userOrderInfo.operatorType, isPromotional, packageName),
            orderTips: getPureText(orderTips),
            smsModalTheme,
            isPromotional,
          }),
          {
            onBottom: !!smsModalTheme,
          },
        );
        return;
      }

      default: {
        showOrderMobileInput(AWARD_TYPES.RIGHTS);
        return;
      }
    }
  };

  return (
    <div
      className={classNames('lottery-btn', {
        disabled: isReceived,
      })}
      id="gift-multilottery"
      style={commonStyle}
      onClick={receiveGift}
      data-gift-btn-type="benefit"
      data-is-received={!!isReceived}
      data-test-id="multi-lottery-button"
    >
      <img className="btn-img" src={isReceived ? receivedBtnImg : tobeReceiveBtnImg} />
    </div>
  );
}
